export default "__VITE_ASSET__oxqiu7jY__"